import {
  IconGauge,
  IconMenu2, IconMenuDeep,
  IconHome,
  IconWallet,
  IconReport,
  IconLogout,
  IconServicemark
} from '@tabler/icons-react';
import { Button, Group, ScrollArea } from '@mantine/core';
import './Sidenavbar.css';
import { Menu } from 'antd';
import { useState } from 'react';
import Home from '../Components/Retailer/Home';
import Dashboard from '../Components/Retailer/Dashboard';
import Topinrequest from '../Components/Retailer/Balance/Topinrequest';
import Wtowretailer from '../Components/Retailer/Balance/wtowretailer';
import Retailerledger from '../Components/Retailer/Reports/Retailerledger';
import Retailertrxnreports from '../Components/Retailer/Reports/Retailertrxnreports';
import Retailertrxnsummary from '../Components/Retailer/Reports/Retailertrxnsummary';
import Retailercommandtds from '../Components/Retailer/Reports/Retailercommandtds';
import { Userauthcontexthooks } from '../Hooks/Userauthcontexthooks';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import Payout from '../Pages/Services/payout';

const mockdata = [
  {
    key: "1",
    label: "Home",
    icon: <IconHome size={18} />,
  },

  {
    key: "2",
    label: "Dashboard",
    icon: <IconGauge size={18} />,
  },
  {
    key: "3",
    label: "Balance",
    icon: <IconWallet size={18} />,
    children: [
      {
        key: "3-main",
        label: "Top In Requests",
      },
      {
        key: "3-1",
        label: "Retailer to Retailer Transfer",
      },
    ],
  },
  {
    key: "6",
    label: "Services",
    icon: <IconServicemark size={18} />,
    children: [
      {
        key: "6-main",
        label: "Payment service",
      },
    ],
  },
  {
    key: "4",
    label: "Reports",
    icon: <IconReport size={18} />,
    children: [
      {
        key: "4-main",
        label: "Ledger Reports",
      },
      {
        key: "4-1",
        label: "Transaction Reports",
      },
      // {
      //   key: "4-2",
      //   label: "Transaction Summary Reports",
      // },
      // {
      //   key: "4-3",
      //   label: "Commission & TDS Reports",
      // },
      // {
      //   key: "4-4",
      //   label: "Fees & Charges Reports",
      // },
    ],
  },
  // {
  //   key: "5",
  //   label: "Support",
  //   icon: <IconHelp size={18} />,
  // },
];

export function NavbarNested() {
  // const links = mockdata.map((item) => <LinksGroup {...item} key={item.label} />);
  const { dispatch } = Userauthcontexthooks();
  const [selectedKey, setSelectedKey] = useState("1"); // Default selected key
  const [collapsed, setCollapsed] = useState(false);
  const Navigate = useNavigate();

  function Logout_user() {
    localStorage.removeItem('user');
    localStorage.removeItem('expiryTime');
    dispatch({ type: 'LOGOUT' });
    message.success('Logout Successfully', 1.5, () => {
      Navigate('/');
    });

  }
  const renderSelectedItem = (key) => {
    switch (key) {
      case "1":
        return <Home Headername={'Home'} />;
      // return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Dashboard Headername={"Dashboard"} />
      //     : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      case "2":
        return <Dashboard Headername={'Dashboard'} />;
      // case "3":
      //   return <Topinrequest Headername={'Top In Requests'}/>;
      case "3-main":
        return <Topinrequest Headername={'Top In Requests'} />;
      case "3-1":
        return <Wtowretailer Headername={'Wallet to Wallet Transfer'} />;
      // case "4":
      //   return;
      case "4-main":
        return <Retailerledger Headername={'Retailer Ledger'} />;
      case "4-1":
        return <Retailertrxnreports Headername={'Retailer Transaction Reports'} />;
      case "4-2":
        return <Retailertrxnsummary Headername={'Retailer Transaction Summary'} />;
      case "4-3":
        return <Retailercommandtds Headername={'Retailer Commission and TDS'} />;
      case "4-4": // fees and charges
        return;

      case "6-main":
        return <Payout Headername={'Payment Service'} />;

      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Buyerlists Headername={"Buyer List"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "sm-1":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Invoicehistory Headername={"Invoice History"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "3-main":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Storelisting Headername={"Store Listing"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "sm-2":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Inventorymangement Headername={"Inventory Mangement"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "4":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Publicinvlink Headername={"Public Invoice Link"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "5":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Refferalsupport Headername={"Refer Others"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "6":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Digicontact Headername={"Contact Us"} Notshowheader={true} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "7":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Websitebuildrform Headername={"Website Builder Form"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "8":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Caservices Headername={"Acccounting Services"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      default:
        return <div>Select an option</div>;
    }
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <nav className={"navbar"} style={{
        width: collapsed ? 80 : 260,
        transition: "all .3s ease",
        overflow: "hidden",
      }}>
        <div className={"header"}>
          <Group justify="space-between">
            {/* <Image
              src={Logo}
              alt="LOGO"
              preview={false}
              height={collapsed ? 35 : 50}
            /> */}

            {collapsed ? (
              <IconMenu2
                size={24}
                style={{ cursor: "pointer" }}
                onClick={() => setCollapsed(false)}
              />
            ) : (
              <IconMenuDeep
                size={24}
                style={{ cursor: "pointer" }}
                onClick={() => setCollapsed(true)}
              />
            )}
          </Group>
        </div>

        <ScrollArea className={"links"}>
          <div className={"linksInner"} style={{ overflow: "hidden", }}>
            <Menu
              defaultSelectedKeys={['1']}
              defaultOpenKeys={['sub1']}
              mode="inline"
              inlineCollapsed={collapsed}
              items={mockdata}
              onSelect={(e) => setSelectedKey(e.key)} // Update selected key
            />
          </div>
        </ScrollArea>


        <div className={"footer"}>
          <Button size='xs' color='red' variant='light' fullWidth radius={0}
            rightSection={collapsed ? <IconLogout size={20} /> : <>Logout <IconLogout size={20} style={{ marginLeft: '5px' }} /> </>} onClick={Logout_user}>

          </Button>
        </div>
      </nav>
      <div
        style={{
          flex: 1,
          // marginLeft: collapsed ? 80 : 260,
          transition: "all .3s ease",
          // padding: 5,
        }}
      >
        {renderSelectedItem(selectedKey)}
      </div>
    </div>
  );
}